:host {
  display: block;
}

.zeudy-audio {
  $pre: &;

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Plyr tweaks
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  &__wrapper {
    border-radius: var(--zeudy-player-border-radius, 0px);
    .plyr--audio .plyr__controls {
      padding: 0;
    }

    .plyr--audio .plyr__control.plyr__tab-focus,
    .plyr--audio .plyr__control:hover,
    .plyr--audio .plyr__control[aria-expanded='true'] {
      background: var(--plyr-audio-controls-background);
      color: var(--plyr-audio-control-color);
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Wrapper
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  &__wrapper {
    display: flex;
    background: var(--plyr-audio-controls-background, #fff);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Controls Container
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  &__controls-wrapper {
    padding: calc(var(--plyr-control-spacing, 10px) * 2);
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;

    // handle style tweaks for poster.
    .has-poster & {
      padding: calc(var(--plyr-control-spacing, 10px) * 3);
    }
    // handle style tweaks for play-large with no poster.
    .has-play-large:not(.has-poster) & {
      padding-left: 0;
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Title
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  &__title,
  &__mobile-title {
    font-size: 18px;
    font-weight: 500;
    line-height: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--plyr-audio-control-color);
  }

  &__title {
    margin: calc(var(--plyr-control-spacing, 10px) / 2);
    margin-top: 0;
    text-wrap: wrap;
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Poster
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  &__poster-wrapper {
    position: relative;
    width: 100px;
    min-height: 100px;
    flex: 0 0 100px;

    img {
      border-radius: var(--zeudy-player-border-radius, 0px) 0 0 var(--zeudy-player-border-radius, 0px);
      width: 100%;
      height: 100%;
      object-fit: cover;
      aspect-ratio: 1;
      display: block;
    }

    // handle style tweaks for poster.
    .has-poster & {
      width: 140px;
      height: 140px;
      flex: 0 0 140px;
    }
  }

  &__poster {
    width: 100%;
    height: 100%;
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Play Large Button
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  &__large-play-button {
    user-select: none;
    cursor: pointer;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    color: white;
    border-radius: 100%;
    background: var(--plyr-audio-control-color);
    color: var(--plyr-audio-controls-background);

    &.is-relative {
      position: relative;
      top: auto;
      left: auto;
      transform: none;
    }

    .has-light-background.has-poster & {
      background: var(--plyr-audio-controls-background);
      color: var(--plyr-audio-control-color);
    }
    .has-dark-background.has-poster & {
      background: var(--plyr-audio-control-color);
      color: var(--plyr-audio-controls-background);
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Play Large Icon
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  &__icon-play,
  &__icon-pause {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    fill: currentColor;
    display: block;
    transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
    margin: 0 auto;
    text-align: center;
  }
  &__icon-pause {
    opacity: 0;
    visibility: hidden;

    #{$pre}__wrapper.is-playing & {
      opacity: 1;
      visibility: visible;
    }
  }
  &__icon-play {
    margin-left: 2px; // optically center
    opacity: 1;
    visibility: visible;
    #{$pre}__wrapper.is-playing & {
      opacity: 0;
      visibility: hidden;
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Mobile sizing
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  &__poster-wrapper-mobile {
    display: none;
    min-width: 0;

    .zeudy-audio__large-play-button {
      flex: 0 0 50px;
    }
  }

  &__wrapper.breakpoint-small {
    flex-direction: column;

    #{$pre}__controls-wrapper {
      padding: calc(var(--plyr-control-spacing, 10px) * 2);
    }

    &.has-poster #{$pre}__title {
      text-align: center;
      margin: calc(var(--plyr-control-spacing, 10px) * 1.5);
    }

    &.has-poster #{$pre}__poster-wrapper {
      margin: 30px auto auto auto;
      overflow: hidden;
      border-radius: var(--zeudy-player-border-radius, 0px);
      width: 225px;
      height: 225px;
      flex: 0 0 225px;
    }

    &.has-play-large:not(.has-poster) #{$pre}__poster-wrapper,
    &.has-play-large:not(.has-poster) #{$pre}__title {
      display: none;
    }

    &.has-play-large:not(.has-poster) #{$pre}__poster-wrapper-mobile {
      display: flex;
      align-items: center;
      gap: 1em;
      margin-bottom: calc(var(--plyr-control-spacing, 10px) * -1);
      padding: calc(var(--plyr-control-spacing, 10px) * 2) calc(var(--plyr-control-spacing, 10px) * 2) 0 calc(var(--plyr-control-spacing, 10px) * 2);
    }
  }
}

//  Stacked View
.skin-stacked.zeudy-sticky-audio {
  .zeudy-audio__wrapper {
    height: 115px;
  }
  .has-poster {
    .zeudy-audio__controls-wrapper {
      padding: 20px;
    }
    .zeudy-audio__poster-wrapper {
      width: 115px;
      height: 115px;
      flex: 0 0 115px;
    }
  }
}

// skin-default
.zeudy-sticky-audio {
  .zeudy-audio__wrapper {
    height: 100px;
  }
  .has-poster {
    .zeudy-audio__controls-wrapper {
      padding: 20px;
    }
    .zeudy-audio__poster-wrapper {
      width: 100px;
      height: 100px;
      flex: 0 0 100px;
    }
  }
}

// Basic Viwe

.action-bar-active {
  .zeudy-audio__wrapper {
    border-radius: var(--zeudy-player-border-radius) var(--zeudy-player-border-radius) 0px 0px;
  }
}

@media screen and (max-width: 782px) {
  .zeudy-sticky-audio {
    .zeudy-audio__poster-wrapper-mobile {
      display: flex;
      align-items: center;
      gap: 1em;
      margin-bottom: calc(var(--plyr-control-spacing, 10px) * -1);
      padding: calc(var(--plyr-control-spacing, 10px) * 2) calc(var(--plyr-control-spacing, 10px) * 2) 0 calc(var(--plyr-control-spacing, 10px) * 2);
    }
    .zeudy-audio__poster-wrapper,
    .zeudy-audio__title {
      display: none;
    }
    .zeudy-audio__wrapper {
      height: 140px;
    }
    .has-poster .zeudy-audio__controls-wrapper {
      padding: 0px;
    }
    .zeudy-audio__poster-wrapper-mobile {
      .zeudy-audio__large-play-button {
        flex: 0 0 40px;
        height: 40px;
      }
    }
  }
}
